import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import axios from "axios";
import ConfirmDialog from "../global/ConfirmDialog";
import * as sweetalert from "sweetalert";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
import { getAllServices } from "../../../services/Services";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
 

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport  csvOptions={{
          fileName: "الحسابات الغير مدفوعة",
          utf8WithBom: true,
        }}/>
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const OrderPaid = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [ServicesData, setServices] = useState([]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setIsLoading(true);
  
    axios
      .get(
        `${BaseUrl}/api/getorderToMe/all`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        const filteredData = res.data.data.filter((row) =>
          row.order_type === "UnPaid"
        );
        setUsers(filteredData);
        setIsLoading(false);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });
      getAllServices()
      .then((res) => {
        setServices(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setServices([]);
        setIsLoading(false);
      });
    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleActivepaid = id => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    axios
      .get(`${BaseUrl}/api/TransferToPaid/${id}`,  {
        withCredentials: true,
      })
      .then((res) => {
     
        setUsers(users.filter((row) => row.id !== id));
    
    },[]);
  };
  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };
  const handleAccept = (id, order_type) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    if (order_type === "Paid") {
      const data = {
        order_id: id,
        status_type: "Complete",
      };

      axios
        .post(
          `${BaseUrl}/api/TransferOrder`,
          data,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res.data.status === true) {
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
            }).catch((error) => {
              console.error("Error in SweetAlert Promise chain:", error);
            });
            setUsers(users.filter((row) => row.id !== id));
          }
          else{
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              })
          }
        });
    } else {
      const data = {
        order_id: id,
        status_type: "Accept",
      };

      axios
        .post(
          `${BaseUrl}/api/TransferOrder`,
          data,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res.data.status === true) {
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              window.location.reload();
            }).catch((error) => {
              console.error("Error in SweetAlert Promise chain:", error);
            });
            setUsers(users.filter((row) => row.id !== id));
          }
          else{
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                window.location.reload();
              })
          }
        });
    }
  };
  const handleDeleteorder = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    axios
      .get(
        `${BaseUrl}/api/rejectOrder/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setUsers(users.filter((row) => row.id !== id));
      });
  };
  const columns = [
    {
      field: "from_staff_name",
      headerName: "اسم المرسل",
      headerAlign: "center",
      align: "center",
      flex:1,
    
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "to_staff_name",
      headerName: "اسم المستقبل",
      headerAlign: "center",
      align: "center",
      flex:1,
    
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "from_staff_number",
      headerName: "رقم المرسل",
      headerAlign: "center",
      align: "center",
      flex:1,
    
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "to_staff_number",
      headerName: "رقم المستقبل",
      headerAlign: "center",
      align: "center",
      flex:1,
    
      cellClassName: "name-column--cell",
      editable: false,
    },

    {
      field: "order_type",
      headerName: "نوع الطلب",
      headerAlign: "center",
      align: "center",
      flex:1,
      editable: false,
      renderCell: (params) => {
        const isActive = params.value === "Paid";
        return isActive ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>مدفوع</p>
        ) : (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>غير مدفوع</p>
        );
      },
    },
    {
      field: "status_type",
      headerName: "حالة الطلب",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
      renderCell: (params) => {
        const isActive = params.value;
        return isActive === "Pending" ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>معلق</p>
        ) : isActive === "Complete" ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>مقبول مدفوع</p>
        ) : isActive === "Accept" ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>مقبول غير مدفوع</p>
        ) : (
          <p style={{ color: "#403e3e", fontSize: "15px" }}></p>
        );
      },
    },
    {
      field: "amount",
      headerName: "كمية الرصيد ",
      type: "number",
      headerAlign: "center",
      align: "center",
      flex:1,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      flex:1,
      cellClassName: "actions",
        renderCell: (params) => {
          return (
            <Box>
              {params.row.status_type === "Complete" ||
            params.row.status_type === "Accept" ? (
              <></>
            ) : (
              <>
              <Button
                variant="contained"
                color="primary"
                className="activationbtn"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "هل تريد القيام بهذه العملية",
                    subTitle: "لايمكن التراجع عن هذه العملية",
                    onConfirm: () => {
                      handleAccept(params.row.id, params.row.order_type);
                    },
                  });
                }}
              >
                قبول
              </Button>
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
              ,
              <Button
                variant="contained"
                className="activationbtn3"
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "هل تريد القيام بهذه العملية",
                    subTitle: "لايمكن التراجع عن هذه العملية",
                    onConfirm: () => {
                      handleDeleteorder(params.row.id);
                    },
                  });
                }}
              >
                رفض
              </Button>
              </>
            )}
              <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
              ,
            </Box>
          );
        },
    },
  ];
  const staff_type = localStorage.getItem("staff_type");
  const mobile_number_login = localStorage.getItem("mobile_number_login");
  return (
    <Box m="2px 5px 0px 5px">
      <Header
      />
 {
        ServicesData[5]?.name == "Orders"  &&  ServicesData[5]?.is_active == 1? (
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',
        }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
      ):  ServicesData[5]?.name == "Orders" &&
        ServicesData[5]?.is_active == 0 && staff_type == "Admin" &&
                  mobile_number_login == "0950555563"?(
                    <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',
        }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
                     
      ): ServicesData[5]?.name == "Orders"  &&  ServicesData[5]?.is_active == 0?(
              <div class="services-no-available">
        هذه الخدمة غير متاحة
        <img src="7703205.webp"/>

        </div>
                        ):(<></>)}
    </Box>
  );
};

export default OrderPaid;
